import React from 'react';
import MapComponent from '@components/map/MapComponent';

const RideScreen: React.FC = () => <MapComponent showLocation={false} />;

export default RideScreen;
